import { render, staticRenderFns } from "./ServicesReservationTreatmentPlanAdd.vue?vue&type=template&id=64536254&scoped=true&"
import script from "./ServicesReservationTreatmentPlanAdd.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationTreatmentPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64536254",
  null
  
)

export default component.exports